import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaClock, FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

const Contact = () => {

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <motion.div
        className="bg-highlight text-primary py-16"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="max-w-7xl mx-auto px-4 text-center">
          <motion.h1
            className="text-4xl md:text-5xl font-serif font-bold mb-4"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Contact Us
          </motion.h1>
          <motion.p
            className="text-xl text-secondary max-w-2xl mx-auto"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            We'd love to welcome you to Pokhara. Reach out and let's make your stay unforgettable.
          </motion.p>
        </div>
      </motion.div>

      {/* Hotel Information and Opening Hours */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 px-4 py-16">
        {/* Contact Info */}
        <motion.div
          className="bg-highlight p-8 rounded-2xl shadow-lg"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="text-2xl font-serif font-bold text-primary mb-6">Hotel Information</h3>
          <div className="space-y-4">
            <div className="flex items-start">
              <FaMapMarkerAlt className="text-accent mt-1 mr-4 flex-shrink-0" />
              <div>
                <p className="font-semibold text-primary">Address</p>
                <p className="text-secondary">Gairikhet Marga, Lakeside, Pokhara</p>
              </div>
            </div>
            <div className="flex items-center">
              <FaPhone className="text-accent mr-4 flex-shrink-0" />
              <div>
                <p className="font-semibold text-primary">Phone</p>
                <p className="text-secondary">+977 9856063333/9856032318</p>
              </div>
            </div>
            <div className="flex items-center">
              <FaEnvelope className="text-accent mr-4 flex-shrink-0" />
              <div>
                <p className="font-semibold text-primary">Email</p>
                <p className="text-secondary">hoteladmirepokhara@gmail.com</p>
              </div>
            </div>
          </div>
          <motion.a
            href="https://maps.google.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-6 bg-primary hover:bg-primary/90 text-background font-semibold py-3 px-6 rounded-lg transition-colors duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Directions
          </motion.a>
        </motion.div>

        {/* Opening Hours */}
        <motion.div
          className="bg-highlight p-8 rounded-2xl shadow-lg"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="flex items-center mb-6">
            <FaClock className="text-accent mr-4" />
            <h3 className="text-2xl font-serif font-bold text-primary">Opening Hours</h3>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-secondary">Monday - Sunday</span>
              <span className="font-semibold text-primary">24/7</span>
            </div>
            <div className="flex justify-between">
              <span className="text-secondary">Reception</span>
              <span className="font-semibold text-primary">24/7</span>
            </div>
            <div className="flex justify-between">
              <span className="text-secondary">Check-in</span>
              <span className="font-semibold text-primary">2:00 PM</span>
            </div>
            <div className="flex justify-between">
              <span className="text-secondary">Check-out</span>
              <span className="font-semibold text-primary">12:00 PM</span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Main Content - for contact form or other */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Add contact form here if needed */}
      </div>
    </div>
  );
};

export default Contact;